import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const LinkedListsAndApplications = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Singly Linked Lists, Doubly Linked Lists, Circular Linked Lists & Applications: Polynomial Manipulation"
    videos={[
      "https://www.youtube.com/embed/IiL_wwFIuaA",
      "https://www.youtube.com/embed/58YbpRDc4yw",
      "https://www.youtube.com/embed/cFHZ-a87Vp4",
      "https://www.youtube.com/embed/_XjzQzZY2gg",
      "https://www.youtube.com/embed/XmRrGzR6udg"
    ]}
    takeaways={[
      { text: "Learn the codes and be clear about implementations; scenario-based questions are possible." },
      { text: "Learn the differences between array and linked list." }
    ]}
    questions={[
      "Develop a pseudocode and illustrate with neat diagrams to group all odd nodes followed by the even nodes for the given singly linked list 2,1,3,5,6,4,7.",
      "Develop a pseudocode to find the node having the largest value in the circular linked list having the values 20,14,181,100. Assume that the circular linked list is having one reference last/tail and the reference head is not available."
    ]}
    exampleVideos={[]}
  />
);
}

export default LinkedListsAndApplications;
